import React from 'react';
import { View, StyleSheet, Image, TouchableWithoutFeedback, TouchableOpacity,
     ScrollView, ActivityIndicator, Dimensions } from 'react-native';
import { Surface, Avatar, Searchbar } from 'react-native-paper';
import { Text, Styles, Config } from './../../components/UI-Components';
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import Icons from "react-native-vector-icons/FontAwesome";
import { connect } from 'react-redux';
import { getCourseMaterial, clearAllCourseMaterialData, getBookMarks , addBookMark, clearAddBookMarkData, deleteBookMark  } from './../../store/action';
import { courseMaterials } from './../../store/selector';
// import ToasterComponent from './../snackBarComponent';
// import BackHandlerAndroid from './../AndroidBackHandler';
// import OfflineHandler from './../OfflineHandler';
// import AdsScreen from './../Ads';
import Toaster from './../../components/snackBar_toaster';
import PlayArrow from  '@material-ui/icons/PlayArrow';
import PictureAsPdf from  '@material-ui/icons/PictureAsPdf';
import Description from  '@material-ui/icons/Description';
import Lock from  '@material-ui/icons/Lock';
import NavigateNext from  '@material-ui/icons/NavigateNext';
import ShowContentScreen from './../showContentScreen';
import Header from "./../../components/Header/index";
import { bookmarksSelector } from './../../store/selectors';
import { COURSE_MATERIAL,  LESSON_CONTENT_SCREEN } from './../../store/constants/bookmarkConstants';
import Container from '@material-ui/core/Container';
import LoadingComponent from "./../../components/LoaderComponent";
import {ContentComponent} from "./../../components";
import Favorite from "@material-ui/icons/Favorite";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";
import moment from 'moment';
import { is } from 'immutable';


const isValidDate = date => moment(date).isValid();
const avatarImg = require('./../../assets/avatar.jpeg');
const videoIcon  = require('./../../assets/cinema.png');
const calendarIcon  = require('./../../assets/hourglass/hourglass.png');
const epubIcon  = require('./../../assets/epub.png');
const TestIcon  = require('./../../assets/a-logo/a-logo.png');
const pdfIcon  = require('./../../assets/document.png');





class LessonContent extends React.Component {
    state = {
        query: '',
        materials: [],
        showToast: false,
        toasterMessage: ''
    }

    componentDidMount() {
         this.getCourseMaterials();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.materials !== this.props.materials) {
            this.setState({
                materials: this.props.materials
            })
        
        }
        if(prevProps.addBookMarkResponse !== this.props.addBookMarkResponse) {
            if(this.props.addBookMarkResponse) {
                this.props.getBookMarks();
            }
        }
    }

    componentWillUnmount() {
        this.props.clearAllCourseMaterialData();
    }

    getCourseMaterials = () => {
        // const lessonPlannerId = this.props.navigation.getParam('lessonPlannerId', null);
        const { state = {}} = this.props.location;
        const { lessonPlannerId=null} = state;
        if(lessonPlannerId) {
            this.props.getCourseMaterial(lessonPlannerId);
        }
    }

    showToaster = (msg) => {
        this.setState({
          showToast: true,
          toasterMessage: msg
        })
      }

    handleSearch = (text) => {
        const formatData = text.toLowerCase();

        this.setState({ query: text }, () => {
            const filteredData = this.props.materials && this.props.materials.length && this.props.materials.filter(x => {
                if (x && x.title && x.title.toLowerCase().includes(formatData)) {
                    return x;
                }
            })
            this.setState({ 
                materials: filteredData
            })
        })

    }

    // showToaster = (msg, time=1000) => this.refs.toast.show(msg, time)

    isAdAvailable = (value) => {
        this.setState({
            isAdShow: value
        })
     }

     addBookmarks = () => {     
        const { state = {}} = this.props.location;
        const { lessonPlannerId=null,
             mentor_name,
             facultyInfo,
             title,fullTitle
            } = state || {};  
        console.log(fullTitle, "sdfmsmdkf")
        const data = {
            content_id: lessonPlannerId,
            content_name: 'titleId',
            content_url: "null",
            screen_name: LESSON_CONTENT_SCREEN,
            type: COURSE_MATERIAL,
            image_url: '',
            description: null,
            title: fullTitle
        }
        this.props.addBookMark(data)
        
    }

    render() {    
        const { isUserPaid, isFree, loading, errInfo, error } = this.props;
        const { materials } = this.state;    
        const { state = {}} = this.props.location;
        const { lessonPlannerId=null,
             mentor_name,
             facultyInfo,
             title
            } = state || {};
        const { ids ={}, bookmarks=[] } = this.props.courseMaterial || {};
        let isBookmarked = ids && ids[lessonPlannerId];
        const bookmark = bookmarks.find(c => c.content_id === lessonPlannerId);
        return(
            <>
            <Header
                title="Course Content"
                headerRight
                headerRightClick={() => this.props.history.push('/Home')}
                headerLeftClick={() => this.props.history.goBack()}
                backButton={true}
                // headerRightClick={() => alert()}
                back
             />
             <Container maxWidth='lg'>
            <div className='main-component'
               
            >
         
            <ScrollView >
                {/* {
                   !this.props.loading && !this.props.error && 
                    <Searchbar
                        placeholder="Search..."
                        onChangeText={_query => { this.setState({ query: _query }) }}
                        value={this.state.query}
                        style={{ margin: 8 }}
                        onChangeText = { this.handleSearch}
                        // onFocus={() => {
                        //     this.setState({
                        //         isSearch: true
                        //     })
                        // }}
                    />
                } */}
                {
                    loading && <View style={styles.container}>
                        <LoadingComponent styles={{width: 250, height: 250}} />
                    </View>
                }
                     {/* {
                    !loading && !error &&
                
                <View style={{flex:1,  paddingVertical: 10, marginHorizontal: 12}}>
                    <View style={{flex: 1, 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        flexDirection: 'row'
                        }}
                    >
                    <Text style={styles.headerText}>
                        {this.props.course_code}
                    </Text>
                    <TouchableOpacity
                         hitSlop={{
                            top: 8,
                            bottom: 8,
                            left: 8,
                            right: 8
                        }}
                        activeOpacity={.9}
                        onPress={() => {                                
                            if(isBookmarked){
                                this.props.deleteBookMark(bookmark?.id)
                                
                            }      
                            if(!isBookmarked) {
                                this.addBookmarks()
                                
                            }                                                  
                            
                        }}
                    
                    >
                            <View style={{width: 32, height: 32, borderRadius: 100,
                            backgroundColor: '#fff', 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            elevation: 4,
                            marginRight: 10
                            }}
                            >
                                {
                                isBookmarked ?  <Favorite size={20} 
                                style={{color: Styles.dangerColor}}
                                /> :   <FavoriteBorder size={20} />
                              } 
                            </View>
                        </TouchableOpacity>
                    </View>
                    <View style={{flex: 1, 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        flexDirection: 'row',
                        marginTop: 5,
                        width: '100%'
                        }}
                    >
                    <Text
                     style={[styles.headerText, {fontWeight: '600', color: '#000', alignSelf: 'flex-start'}]}
                     elipsizeMode='tail'
                     numberOfLines={1}
                     >
                    {title[0]?.[0]}
                    </Text>
                   <View
                    style={{  width: '80%',flexDirection: 'row', justifyContent: 'flex-end', flexWrap: 'wrap', alignItems: 'flex-end'}}
                    >
                    <Text
                     style={[styles.headerText, {fontWeight: '700', color: '#000', flexWrap: 'wrap',textAlign: 'right',}]}
                     elipsizeMode='tail'
                     numberOfLines={2}
                     >
                    {title[0]?.[1]}
                    </Text>
                   </View>
                 
                    </View>

                </View>
                } */}

                {
                    error && <View style={styles.container}><Text>{errInfo && typeof errInfo === 'string' ? errInfo : 'something went wrong...'}</Text></View>
                }

                {/* <View style={{paddingHorizontal: 12, paddingBottom: this.state.isAdShow ? 40 : 0}}>   
                    {
                        materials && materials.length > 0 && materials.map((material, index) => {
                            console.log(material, "ASdsda")
                            const {title, file_type, content_url,
                                 html_content, is_paid,course_id, exam_id, lesson_planner_id, id,
                                 video_type, scheduled_date_time
                                } = material;
                            return ( 
                            <TouchableWithoutFeedback
                                onPress = {()=> {            
                                                       
                                    if(isFree || isUserPaid || !is_paid) {
                                        // this.props.navigation.navigate('ShowContentScreen', {
                                        //     contentUrl: content_url,
                                        //     contentType: file_type,
                                        //     html_content: html_content,
                                        //     title: title,
                                        //     id: id,
                                        //     subjectId: course_id,
                                        //     examId: exam_id,
                                        //     topicId: lesson_planner_id,
                                        //     formLibrary: false,
                                        // })
                                        if(file_type === "scheduled") return this.showToaster(isValidDate(scheduled_date_time) ? `Live should starts in ${moment(scheduled_date_time).fromNow()}`: 'Not Scheduled', 2000)
                                        if((!content_url && (file_type === 'test' || file_type === 'epub')) || content_url) {
                                            this.setState({
                                                showContent: true,
                                                contentData: {
                                                   contentUrl: content_url,
                                                   contentType: file_type,
                                                   html_content,
                                                   title,
                                                   id,
                                                   subjectId: course_id,
                                                   examId: exam_id,
                                                   topicId: lesson_planner_id,
                                                   formLibrary: false,
                                                   videoType: video_type || null,
                                                    mentor_name,
                                                    facultyInfo
                                                }
                                            })
                                            return null;
                                        }
                                        if(!content_url) return this.showToaster("Not available");
                                    }
                                    return this.showToaster('Please purchase to Continue.');
                                  

                                }}
                            >
                                <View style={styles.courseWrapper}>
                                    
                                <Image
                                       source={
                                        file_type === 'live' ? videoIcon
                                        :
                                        file_type === "scheduled" 
                                        ?
                                        calendarIcon
                                        :
                                        file_type === 'video'
                                        ?
                                         videoIcon 
                                        : 
                                        file_type === 'test' 
                                        ?
                                        TestIcon 
                                        : 
                                        file_type === 'pdf' 
                                        ?
                                        pdfIcon
                                        :
                                        file_type === 'epub'
                                        ?
                                        epubIcon
                                        :
                                        null
                                       }
                                       style={{
                                           width: 32,
                                           height: 32
                                       }}
                                     />
                                        <View style={styles.titleWrapper}>
                                        {
                                                file_type === "scheduled" 
                                                ?
                                                <Text 
                                                ellipsizemode={'tail'}
                                                numberOfLines={2}
                                                style={styles.title}
                                                 
                                            > Live starts { isValidDate(scheduled_date_time) ? moment(scheduled_date_time).format('MMMM Do YYYY, h:mm a') : '-'}</Text> 
                                            :
                                                <Text 
                                                ellipsizemode={'tail'}
                                                numberOfLines={2}
                                                style={styles.title}
                                                 
                                                >{title}</Text>    
                                                                                    
                                            }                                      
                                        </View>
                                        <View
                                          style={{flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}
                                        >
                                            {
                                                file_type === 'live'
                                                ?
                                                <View style={{flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginRight: 20,}}>
                                                 <View style={{width: 12 ,
                                                        height: 12,
                                                        backgroundColor: Styles.dangerColor,
                                                        borderRadius: 50,
                                                        marginRight: 10
                                                    }}></View>
                                                    <Text style={{fontSize: 14, color: Styles.dangerColor, }}>LIVE</Text>
                                                    </View>
                                                :
                                                 null
                                            }

{
                                            (isUserPaid || isFree || !is_paid)
                                            ?
                                             <NavigateNext style={{marginLeft: 'auto', alignSelf: 'center', color:'rgba(0,0,0,0.7)', width: 20, height: 20}}/>
                                            :
                                            <Lock style={{marginLeft: 'auto', alignSelf: 'center', color:'rgba(0,0,0,0.7)', width: 20, height: 20}}/>
                                        }
                                        </View>
                                      
                                    </View>
                            </TouchableWithoutFeedback>  
                        )   
                        })
                    }
                                     
                </View> */}
                

                    <View style={{ 
                        marginTop: 10, 
                        flex: 1,
                         marginHorizontal: 10, 
                         marginBottom: 20, 
                         flexDirection: 'row', 
                        alignItems: 'center', 
                        justifyContent: 'flex-start', 
                        flexWrap: 'wrap' ,
                        alignSelf: 'center'
                            }}>

                        {
                            materials && materials.length > 0 && materials.map((material, index) => {
                                const {title, file_type, content_url,
                                    html_content, is_paid,course_id, exam_id, lesson_planner_id, id,
                                    video_type, scheduled_date_time, description
                                   } = material;
                                return <ContentComponent
                                    material={material}
                                    key={index}
                                    navigation={this.props.history}
                                    isUserPaid={isUserPaid} isFree={isFree}
                                    onPress = {()=> {      
                                        const  isUrlTrue = material.file_type === 'video' &&  material &&  material.content_url &&(material.content_url.includes('https') || material.content_url.includes('http'));                
                                        if(isFree || isUserPaid || !is_paid) {

                                            if(file_type === "scheduled") return this.showToaster(isValidDate(scheduled_date_time) ? `Live should starts in ${moment(scheduled_date_time).fromNow()}`: 'Not Scheduled', 2000)
                                            if((!content_url && (file_type === 'test' || file_type === 'epub')) || content_url) {
                                                this.setState({
                                                    showContent: true,
                                                    contentData: {
                                                       contentUrl: content_url,
                                                       contentType: file_type,
                                                       html_content,
                                                       title,
                                                       id,
                                                       subjectId: course_id,
                                                       examId: exam_id,
                                                       topicId: lesson_planner_id,
                                                       formLibrary: false,
                                                       videoType: video_type || null,
                                                        mentor_name,
                                                        facultyInfo,
                                                        isUrlTrue: isUrlTrue,
                                                        isMaterialTest: true,
                                                        description
                                                    }
                                                })
                                                return null;
                                            }
                                            if(!content_url) return this.showToaster("Not available");
                                        }
                                        return this.showToaster('Please purchase to access the content.');
                                      
    
                                    }}
                                />



                            })


                        }


                    </View>
     
            </ScrollView>
            {/* <AdsScreen screenName={'LessonContent'}
              
               isAdCallBack={() => this.isAdAvailable(true)}
               /> */}
            <Toaster show={this.state.showToast}
              message={this.state.toasterMessage}
              handleClose={() => {
                  this.setState({
                    showToast: false,
                    toasterMessage: ''
                  })
              }}
              />
  
            </div>
            </Container>
            {
                this.state.showContent ?
                 <ShowContentScreen
                 contentData={this.state.contentData}
                 open={this.state.showContent}
                 handleClose={() => this.setState({showContent: false})}
                 />
                 : null
            }
            </>

        )
    }
}

const mapStateToProps = state => {
    const { isUserPaid, isFree, materials , course_code, course_name} = courseMaterials(state);
    const bookmarkInfo = bookmarksSelector(state.allBookMarks);
    const addBookMarkResponse =  state?.addBookMark?.response?.bookmark;
    const deleteBookMarkInfo = state?.deleteBookMark?.response?.status === 'Success';
    const addBookMarkLoading = state?.addBookMark?.loading;
    return {
        isUserPaid, isFree, materials,        
        loading: state.courseMaterial && state.courseMaterial.loading,
        error: state.courseMaterial && state.courseMaterial.error,
        errInfo: state.courseMaterial && state.courseMaterial.errInfo && state.courseMaterial.errInfo.data && state.courseMaterial.errInfo.data.message,
        bookmarkInfo,
        addBookMarkResponse,
        deleteBookMarkInfo,
        addBookMarkLoading,
        courseMaterial: bookmarkInfo?.courseMaterial,
        course_code,
        course_name
    }
}

export default connect(mapStateToProps, {getCourseMaterial, clearAllCourseMaterialData,
    getBookMarks , addBookMark, clearAddBookMarkData, deleteBookMark 
})(LessonContent)

const styles = StyleSheet.create({
    courseWrapper: {
        paddingHorizontal: 8,
        paddingVertical: 12,
        justifyContent: 'flex-start',
        // alignItems: '',
        flexDirection: 'row',
        borderWidth: 0.2,
        borderRadius: 10,
        marginBottom: 12,
        borderColor: '#ccc',
        marginTop: 10,
        cursor: 'pointer',

    },
    titleWrapper: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignSelf: 'center',
        marginLeft: 20,
        flex: 1,
    
    },
    title: {
        fontSize: 18,
        color: 'rgba(0,0,0,0.7)',
        fontWeight: '500',
        paddingRight: 5
        
     
    },
    container: {
        flex: 1, 
        justifyContent: 'center', 
        alignItems: 'center'
    }
})